import { useCallback, useEffect, useState } from 'react';

import { useStoreData } from '../';

/**
 * TODO: Add types - heavely, refactor
 */
export const useFactorData = () => {
    const storyblok = useStoreData().storyblok.FactorgroupItems.items;

    const factorGroups = useStoreData().storyblok.FactorgroupItems.items as any;
    const { scoreData } = useStoreData().user;

    /**
     * We are splitting all the factors redeived from API into
     * two separate lists. These values are set once the data is loaded from
     * CMS.
     *
     * One with key negative === false (the green slider)
     * Second one with key negative === true (the orange slider)
     */

    const [positiveFactors, setPositiveFactors] = useState([]);
    const [negativeFactors, setNegativeFactors] = useState([]);

    const getGroupDataByFactorName = useCallback(
        (factorName) => {
            const { heading, buttonLabelPositive, buttonLabelNegative } =
                factorGroups.find((f: any) =>
                    f.content.factorItems.find(
                        (fi: any) => fi.name === factorName,
                    ),
                ).content;

            return { heading, buttonLabelPositive, buttonLabelNegative };
        },
        [factorGroups],
    );

    useEffect(() => {
        if (factorGroups && scoreData) {
            /**
             * We are assigning all possible factorItems to a single variable
             * to make the filter (based on factor item type) much easier
             * later on.
             */
            const cmsFactors = factorGroups.flatMap(
                (f: any) => f.content.factorItems,
            );
            const userFactors = scoreData.factors || [];

            /**
             * First, we'are filtering CMS factors (all possibe/defined factors)
             * by factor names that came from the API.
             *
             * Then, we add group data (based on factor name) which is also
             * set in the CMS to each factor.
             *
             * In the end we have an array of user factors which contains all
             * the data from the CMS. The API can return just an array of the
             * factor names and offers, the rest is configurable via
             * `Storyblok->Content->Factors`
             */
            const factors = cmsFactors
                .filter((cmsFactor: any) =>
                    userFactors.some(
                        (userFactor: any) => userFactor.name === cmsFactor.name,
                    ),
                )
                .map((factor: any) => ({
                    ...userFactors.find(
                        (userFactor: any) => userFactor.name === factor.name,
                    ),
                    ...getGroupDataByFactorName(factor.name),
                    ...factor,
                }));

            setPositiveFactors(
                factors.filter((f: any) => f.type === 'positive'),
            );
            setNegativeFactors(
                factors.filter((f: any) => f.type === 'negative'),
            );
        }
    }, [factorGroups, getGroupDataByFactorName, scoreData.factors]);

    return { positiveFactors, negativeFactors };
};
